var r=function(r){return Array.isArray(r)?r.length>0&&r.every((function(r){return"string"==typeof r}))&&r.some((function(r){return Boolean(r)})):"string"==typeof r&&Boolean(r)};export{r as isStringValue};
//# sourceMappingURL=isFunction.mjs.map
